import React, { Fragment, useEffect, useState } from "react";
import ApiProductsList from "../components/apiProductsList/apiProductsList";
import { FRONTEND_ORIGIN_URL_NO_SLASH } from "../config";
import withTracker from "./withtracker";
import { ALL_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import MetaData from "../components/meta/meta";
import { getRouteUrl } from "../routers";
import { ROUTE_PRODUCT_VIEW_ALL } from "../routers/content/product";
import { history } from "../store/store";
import AuthProvider from "../AuthProvider/AuthProvider";
import SectionStart from "../components/sectionStart/sectionStart";
import {
  Sidebar,
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Heading from "../components/heading/heading";
import ProductCategoriesFilter from "../components/apiProductsList/productCategories";
import "../components/pageTitle/pageTitle.css";
import { useDispatch } from "react-redux";
import { setPageTitle, clearPageTitle } from "../actions/pageTitle";

function ApiProductsListHOC(props) {
  const [category, setCategory] = useState(null);
  const dispatch = useDispatch();
  //include criteria state to query key

  useEffect(() => {
    dispatch(setPageTitle("API PRODUCTS"));
    return () => {
      dispatch(clearPageTitle());
    };
  }, [dispatch]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const filterName = urlParams.get("filterName");
    const filterValue = urlParams.get("filterValue");
    const category = filterName && { name: filterName, value: filterValue };

    if (category) {
      setCategory(category);
    }
  }, []);

  const selectApiProductCategory = (category) => {
    if (category) {
      // Encode the category: names like "Payments & Transfers" broke the query string
      const query = new URLSearchParams({
        filterName: category.name,
        filterValue: category.value,
      });
      history.push(`${props.location.pathname}?${query.toString()}`);
    }

    !category && history.push(props.location.pathname);

    setCategory(category);
  };

  return (
    <Fragment>
      <MetaData
        title="API Products"
        url={FRONTEND_ORIGIN_URL_NO_SLASH + getRouteUrl(ROUTE_PRODUCT_VIEW_ALL)}
      />

      <AuthProvider allowedRoles={ALL_USERS}>
        <SectionStart noDivider>
          <SideBar className="api-products-split">
            <SidebarLeft>
              <>
                <SidebarHeader>
                  <Title type="section">
                    <Heading level="1" className="display-effect page-title">
                      API <br /> PRODUCTS
                    </Heading>
                  </Title>
                  <div>
                    <ProductCategoriesFilter
                      selectApiProductCategory={selectApiProductCategory}
                    />
                  </div>
                </SidebarHeader>
                <SidebarViewAll />
              </>
            </SidebarLeft>
            <SidebarRight>
              <ApiProductsList category={category} />
            </SidebarRight>
          </SideBar>
        </SectionStart>
      </AuthProvider>
    </Fragment>
  );
}

export default withTracker(
  withBreadCrumb(ApiProductsListHOC, {
    name: "Products",
    className: "product-area",
  })
);
